<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div id="hotel-laundry"></div>
    <div class="position-relative z-index-1028" v-if="scrollPosition >100">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white">
                  <div class="container px-4 w-100 pt-1 pb-2 box-shadow-nav">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1">
                        <div class="">
                          <router-link :to="'/'+getMerchant.code">
                            <img src="../../../../assets/img/icon/back.png" class="mt-1 top-2" width="20">
                          </router-link>
                        </div>
                      </div>
                      <div class="col-11" v-if="!is_load && error == ''">
                        <div class="">
                          <transition name="fade">
                            <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{data.tagline}}</p>
                          </transition>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="is_load" class="w-100 text-center my-5">
      <loader></loader>
    </div>
    <template v-else>
      <div class="my-4" v-if="error != ''">
        <ErrorMessage :message="error" />
      </div>
      <template v-else>
        <div class="container px-4 pt-4 mb-3">
          <div class="row no-gutters">
            <div class="col-1">
              <router-link :to="'/'+getMerchant.code" class="position-relative" style="top: 10px;">
                <img src="../../../../assets/img/icon/back.png" class="mt-1" width="20">
              </router-link>
            </div>
            <div class="col-11">
              <div class="ml-2-back">
                <p class="mb-0 mb-0 heading-6-1 text-18">{{data.tagline}}</p>
                <p class="mb-0 body-2-2-1">{{data.sub_tagline}}</p>
              </div>
            </div>
          </div>
          <div class="my-3 pb-4 border-bottom">
            <whatsappLink :name="data.tagline" :description="$t('hotel.concierge.fitur.ask-the-hotel-about-this-fitur')" />
          </div>
        </div>
        <div class="container px-4 mb-3 pt-1">
          <div class="row no-gutters border-bottom-2" v-if="data.use_kilos && data.use_unit">
            <div class="col py-2" v-for="tab in tabs.list" :class="tabs.active.id == tab.id ? 'border-bottom-green-4' : 'cursor-pointer'" @click="tabs.active = tab">
              <p class="mb-0 text-center" :class="tabs.active.id == tab.id ? 'body-2-4 text-green' :'body-2-2'">{{tab.name}}</p>
            </div>
          </div>
 
          <div class="w-100 mt-3">
            <ClaimingReward wrapper_class="mb-4"></ClaimingReward>
            
            <template v-if="tabs.active.id == 'kilo' && data.use_kilos">
              <template v-for="kilo in data.kilo_service">
                <menuServiceLaundry :data="kilo" type="kilo"></menuServiceLaundry>
              </template>
            </template>
            <template v-if="tabs.active.id == 'pcs' && data.use_unit">
              <template v-for="pcs in data.pcs_service">
                <menuServiceLaundry :data="pcs" type="pcs" @detail="selectDetailData"></menuServiceLaundry>
              </template>
            </template>
          </div>
        </div>
      </template>
    </template>
    <detailLaundryService v-if="detail_data != null" @close="selectDetailData" :detail_data="detail_data"></detailLaundryService>
    <!-- Pop Up Cart -->
    <template v-if="getConciergeOrder.custom.length > 0">
      <div style="height: 75px;"></div>
      <div class="position-relative" style="z-index: 1028">
        <div class="row no-gutters justify-content-center">
          <div class="fixed-bottom d-block nav-bottom">
            <div class="custom-container-fluid px-0">
              <div class="row justify-content-center no-gutters">
                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                  <div class="container px-4 bg-white height-75px">
                    <div class="row justify-content-center slim-grid-row">
                      <div class="col-12">
                        <router-link :to="'/'+getMerchant.code+'/concierge/laundry/cart'">
                          <div class="rounded-4 bg-orange w-100 px-3 py-3">
                            <div class="row no-gutters">
                              <div class="col-4 align-self-center">
                                <img src="../../../../assets/img/icon/cart.png" width="20" style="vertical-align: -webkit-baseline-middle">
                              </div>
                              <div class="col-8 text-right align-self-center">
                                <p class="text-white text-right mb-0 body-2-4 text-16 text-truncate">{{getConciergeOrder.custom.length}} {{$t('hotel.concierge.service-selected')}}</p>
                              </div>
                            </div>
                          </div>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <!-- <bottom-navbar></bottom-navbar> -->
  </div>
</template>
<script>
  import {mapGetters,mapMutations} from 'vuex';
  import {get} from '@/services/index.js';
  import BottomNavbar from '@/components/hotel/BottomNavbar';
  import {formatCurrency} from '@/utils/index.js'
  import detailLaundryService from '@/components/hotel/concierge/general/detailLaundryService'
  import menuServiceLaundry from '@/components/hotel/concierge/general/menuServiceLaundry'
  import whatsappLink from '@/components/hotel/concierge/general/whatsappLink';
  import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';

  export default{
    components: {
      BottomNavbar,
      detailLaundryService,
      menuServiceLaundry,
      whatsappLink,
      ClaimingReward
    },
    metaInfo(){
      return {
        title: 'Laundry',
        titleTemplate: this.getMetaTitleTemplate
      }
    },
    data() {
      return {
        scrollPosition: null,
        is_load: false,
        error: '',
        data: {},
        detail_data: null,
        tabs:{
          list: [
            {
              id: 'kilo',
              name: this.$t("hotel.concierge.fitur.laundry.per-kilo")
            },
            {
              id: 'pcs',
              name: this.$t("hotel.concierge.fitur.laundry.per-pcs")
            }
          ],
          active: {
            id: 'kilo',
            name: this.$t("hotel.concierge.fitur.laundry.per-kilo")
          }
        }
      }
    },
    computed:{
      ...mapGetters([
        'getMerchant',
        'getConciergeOrder',
        'getMetaTitleTemplate',
        'getMembershipRewardApplied',
        'isMembershipRewardApplied']),
      service_selected(){
        let serv_list = this.getConciergeOrder.custom
        if(serv_list.length > 0){
          let data = ''
          for(let i = 0; i < serv_list.length;i++){
            data += serv_list[i].product.name
            if(i+1 != serv_list.length){
              data += ', '
            }
          }
          return data
        }else{
          return ''
        }
      }
    },
    created(){
      this.$validateActiveReward('concierge-room-dining')
    },
    mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('hotel-laundry').scrollIntoView({
        behavior: 'smooth'
      });
      if(this.getConciergeOrder.custom.length > 0 && this.getConciergeOrder.module != 'laundry'){
        this.resetConciergeOrder()
      }
      this.loadDataApi()
    },
    methods: {
      ...mapMutations(['setConciergeOrderCustom','removeConciergeOrderCustom','resetConciergeOrder','setConciergeOrderCustomModule']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      updateScroll() {
        this.scrollPosition = window.scrollY
      },
      selectDetailData(data='reset'){
        this.detail_data = data == 'reset' ? null : data
      },
      addToCart(service){
        let params = {
          product: service
        }
        let is_cart = this.isProductCart(service)
        if(!is_cart){
          this.setConciergeOrderCustom(params)
          this.setConciergeOrderCustomModule("laundry")
        }else{
          this.removeConciergeOrderCustom(service.id)
        }
      },
      isProductCart(service){
        let serv_record = this.getConciergeOrder.custom.findIndex(x=>x.product.id == service.id)
        if(serv_record == -1){
          return false
        }else{
          return true
        }
      },


      // API FIX
      loadDataApi(){
        this.is_load = true
        this.error = ''
        this.data = {}

        get("CONCIERGE","laundry/general",{
          merchant_id: this.getMerchant.id,
          membership_reward_id: this.isMembershipRewardApplied ? this.getMembershipRewardApplied.id : ''
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.data = res.data
            this.tabs = {
              list: [],
              active: {}
            }
            if(res.data.use_kilos){
              this.tabs.list.push({
                id: 'kilo',
                name: this.$t("hotel.concierge.fitur.laundry.per-kilo")
              }) 
            }
            if(res.data.use_unit){
              this.tabs.list.push({
                id: 'pcs',
                name: this.$t("hotel.concierge.fitur.laundry.per-pcs")
              }) 
              if(!res.data.use_kilos && res.data.pcs_service.length == 1){
                this.selectDetailData(res.data.pcs_service[0])
              }
            }
            this.tabs.active = this.tabs.list[0]
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      }
    }
  }
</script>
<style scoped>

.bg-laundry{
  background-size: cover;
  background-position: center;
}

.bg-opacity{
  background-color: #22222269;
}

@media screen and (max-width: 655px) {
  .mobile-none{
    display: none !important;
  }
} 
</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/laundry/Laundry.vue